$(document).ready(function(){
  $('.lo-slider').slick({
    infinite: true,
    arrows: false,
    slidesToShow: 3, // PCは3枚表示
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 768, // 768px未満（スマホ）では
        settings: {
          slidesToShow: 1 // 1枚表示
        }
      }
    ]
  });
});

const menuIcon = document.getElementById('menu-toggle');
const menu = document.getElementById('menu');

document.addEventListener('click', function (event) {
  const isClickInside = menu.contains(event.target) || menuIcon.contains(event.target);

  if (isClickInside) {
    // トグル動作
    menu.style.display = (menu.style.display === 'block') ? 'none' : 'block';
  } else {
    // 外側クリック時は閉じる
    menu.style.display = 'none';
  }
});

